<div class="max-w-4xl mx-auto px-4 py-16 flex gap-8">
  <aside class="hidden md:block w-52 shrink-0">
    <nav class="sticky top-24 space-y-1 text-sm">
      @for (section of sections; track section.id) {
        <a
          [href]="'#' + section.id"
          class="block px-3 py-1.5 rounded-lg text-gray-500 dark:text-gray-400 hover:bg-purple-50 dark:bg-purple-900/20 hover:text-purple-700 dark:text-purple-300 transition"
        >
          {{ section.title }}
        </a>
      }
    </nav>
  </aside>
  <main class="flex-1 min-w-0">
    <h1 class="text-3xl font-bold text-gray-900 dark:text-white mb-2">Documentation</h1>
    <p class="text-gray-500 dark:text-gray-400 mb-10">
      Référence technique et fonctionnelle de Predivent.
    </p>
    @for (section of sections; track section.id) {
      <section [id]="section.id" class="mb-10">
        <h2
          class="text-lg font-semibold text-gray-900 dark:text-white mb-3 pb-2 border-b border-gray-100 dark:border-slate-700"
        >
          {{ section.title }}
        </h2>
        <p class="text-sm text-gray-500 dark:text-gray-400">{{ section.content }}</p>
        <p class="text-xs text-gray-300 mt-3">
          Documentation complète bientôt disponible.
        </p>
      </section>
    }
  </main>
</div>
